import React from 'react';
import './ShipmentsInsights.css';

const SENTIMENT = {
  positive: { color: '#46BB89', bg: 'rgba(70,187,137,0.1)',  border: 'rgba(70,187,137,0.28)' },
  negative: { color: '#FC8181', bg: 'rgba(252,129,129,0.1)', border: 'rgba(252,129,129,0.28)' },
  warning:  { color: '#F6AD55', bg: 'rgba(246,173,85,0.1)',  border: 'rgba(246,173,85,0.28)' },
  info:     { color: '#63B3ED', bg: 'rgba(99,179,237,0.1)',  border: 'rgba(99,179,237,0.28)' },
};

const DIRECTION_ICON = { up: '↑', down: '↓', flat: '→', spike: '⚡' };

function AiSpinner() {
  return (
    <div className="si-thinking">
      <div className="si-thinking-orb">
        <span className="si-thinking-star">✦</span>
      </div>
      <div className="si-thinking-copy">
        <span className="si-thinking-title">Analysing trend data…</span>
        <span className="si-thinking-sub">Identifying patterns, high runners and anomalies</span>
      </div>
    </div>
  );
}

export default function ShipmentsInsights({ insights, loading, error, onRefresh, stale }) {
  if (!loading && !insights && !error) return null;

  return (
    <div className="si-root">
      <div className="si-header">
        <span className="si-header-badge">
          <span className="si-header-star">✦</span>
          AI Trend Analysis
        </span>
        {stale && !loading && (
          <span className="si-stale">Range changed — results may be outdated</span>
        )}
        {!loading && (
          <button type="button" className="si-refresh-btn" onClick={onRefresh} title="Re-run analysis">
            ↺ Refresh
          </button>
        )}
      </div>

      {loading && <AiSpinner />}

      {!loading && error && (
        <div className="si-error">{error}</div>
      )}

      {!loading && !error && insights && (
        <div className="si-body">
          {insights.summary && (
            <p className="si-summary">{insights.summary}</p>
          )}

          {insights.indicators?.length > 0 && (
            <div className="si-indicators">
              {insights.indicators.map((ind, i) => {
                const meta = SENTIMENT[ind.sentiment] || SENTIMENT.info;
                const icon = DIRECTION_ICON[ind.direction] || '→';
                return (
                  <div
                    key={i}
                    className="si-indicator"
                    style={{ background: meta.bg, borderColor: meta.border }}
                  >
                    <span className="si-indicator-arrow" style={{ color: meta.color }}>{icon}</span>
                    <div className="si-indicator-body">
                      <span className="si-indicator-value" style={{ color: meta.color }}>{ind.value}</span>
                      <span className="si-indicator-label">{ind.label}</span>
                      {ind.note && <span className="si-indicator-note">{ind.note}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="si-sections">
            {insights.positives?.length > 0 && (
              <div className="si-section si-section--pos">
                <div className="si-section-head">
                  <span className="si-section-icon si-section-icon--pos">↑</span>
                  Positive trends
                </div>
                <ul className="si-list">
                  {insights.positives.map((p, i) => <li key={i}>{p}</li>)}
                </ul>
              </div>
            )}
            {insights.concerns?.length > 0 && (
              <div className="si-section si-section--neg">
                <div className="si-section-head">
                  <span className="si-section-icon si-section-icon--neg">⚠</span>
                  Areas of attention
                </div>
                <ul className="si-list">
                  {insights.concerns.map((c, i) => <li key={i}>{c}</li>)}
                </ul>
              </div>
            )}
          </div>

          {insights.actions?.length > 0 && (
            <div className="si-actions">
              <div className="si-actions-head">Recommended actions</div>
              <ol className="si-action-list">
                {insights.actions.map((a, i) => <li key={i}>{a}</li>)}
              </ol>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
